import react from "react";

export const UserContext = react.createContext();